<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    :style="isReduceBlur ? 'background-color: rgba(255,255,255,0.9);' : ''"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Summary Block</div>
        </h4>
        <div
          class="close-properties"
          @click="submitForm(true)"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <div class="section-field input-field">
          <!-- Key Section -->
          <b-form :class="{'error-input' : $v.dataSetup.key.$error}">
            <label> Key </label>
            <j-input
              v-model="dataSetup.key"
              :disabled="isDefault(dataSetup.key)"
              placeholder="Enter block key"
            />
          </b-form>

          <!-- Name Section -->
          <b-form :class="{'error-input' : $v.dataSetup.name.$error}">
            <label> Name </label>
            <j-input
              v-model="dataSetup.name"
              placeholder="Enter block name"
            />
          </b-form>

          <!-- Color Section -->
          <b-form :class="{'error-input' : $v.dataSetup.color.$error}">
            <j-color-picker
              v-model="dataSetup.color"
              :color="dataSetup.color"
              label="Color"
              picker="chrome"
            />
          </b-form>
        </div>

        <!-- Configuration Section -->
        <div class="section-field input-field">
          <h4 class="title-section">Configuration</h4>

          <!-- Block Type -->
          <div
            v-if="isWorkflow"
            :class="{'error-input' : $v.dataSetup.type.$error}"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Block Type</h4>
              </div>
            </div>

            <b-form :class="{'error-input' : $v.dataSetup.type.$error}">
              <div class="wrap-type">
                <div
                  v-for="block in blockTypes"
                  :key="block.type"
                  :class="{'type-active': dataSetup.type === `${block.type}_block`}"
                  class="block-type"
                  @click="dataSetup.type = `${block.type}_block`"
                >
                  <img
                    :src="require(`@/assets/form-ui/summary-block/${block.type}-block.svg`)"
                    :alt="`${block.type}-block`"
                  >
                  {{ block.text }} Block
                </div>
              </div>
            </b-form>
          </div>

          <!-- Is Hidden -->
          <div
            v-if="isWorkflow && isDefault(dataSetup.key)"
            class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Hidden</h4>
              </div>

              <j-switch v-model="dataSetup.is_hidden"/>
            </div>
          </div>

          <!-- Use Filter -->
          <div
            v-if="!isWorkflow || (isWorkflow && !isDefault(dataSetup.key))"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title mb-0">Use Filter</h4>
              </div>
              <j-switch v-model="setFilter"/>
            </div>

            <!-- Filter Configuration -->
            <div
              v-if="setFilter"
              class="mt-4"
            >
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Filter</h4>
                  <p class="configuration-section-desc">
                    Filter data according to the parameters
                  </p>
                </div>

                <!-- Filter Operator -->
                <div class="filter-option">
                  <div class="filter-selected">{{ dataSetup.filterOperator }}</div>
                  <i
                    class="fa fa-chevron-down"
                    @click="showFilterOptions = true"
                  />

                  <!-- Select Filter Operator -->
                  <div
                    v-if="showFilterOptions"
                    class="filter-options"
                  >
                    <p>Operator</p>

                    <div class="d-flex align-items-center justify-content-around">
                      <div
                        v-for="operator in filterOperatorOptions"
                        :key="operator.id"
                        :class="{'operator-selected': operator.id === dataSetup.filterOperator }"
                        class="operator-option"
                        @click="closeFilterOptions(operator.id)"
                      >
                        {{ operator.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filter by Value -->
              <h3 class="configuration-section-subtitle">By Value</h3>
              <div
                v-for="(data, index) in dataSetup.filter"
                :key="index"
                class="div-filter"
              >
                <div class="header-filter">
                  <div class="index">{{ index + 1 }}</div>
                  <i
                    class="fa fa-trash"
                    @click="deleteFilter(index)"
                  />
                </div>
                <b-form class="mb-2">
                  <label> Column </label>
                  <j-single-select
                    v-model="data.key"
                    :error-required="false"
                    :options="variableOptions"
                    :placeholder="'Select Column'"
                    value-format="object"
                    label="label"/>
                </b-form>
                <b-form>
                  <label> Value </label>
                  <j-input
                    v-model="data.value"
                    :error-required="false"
                    :placeholder="'Input Filter Value'"/>
                </b-form>
              </div>

              <div
                class="btn-add-config"
                @click="addFilter">
                + Add Parameter
              </div>

              <div class="separator" />

              <!-- Filter by Function -->
              <h3 class="configuration-section-subtitle">By Function</h3>
              <div class="warning-function d-flex align-items-center">
                <img
                  :src="require('@/assets/icon/warning.svg')"
                  alt="warning">
                <div class="d-flex flex-column">
                  <span class="title">Information</span>
                  <span>
                    If you implement filter function on summary block, then filter function on table view will be missed for filltering
                  </span>
                </div>
              </div>
              <div
                v-for="(data, index) in dataSetup.filter_function"
                :key="index"
                class="div-filter"
              >
                <div class="header-filter">
                  <div class="index">{{ index + 1 }}</div>
                  <i
                    class="fa fa-trash"
                    @click="deleteFilterFunction(index)"
                  />
                </div>
                <b-form class="mb-2">
                  <label> Column </label>
                  <j-single-select
                    v-model="data.key"
                    :error-required="false"
                    :options="variableOptions"
                    :placeholder="'Select Column'"
                    value-format="object"
                    label="label"/>
                </b-form>
                <b-form>
                  <label> Function </label>
                  <j-single-select
                    v-model="data.value"
                    :options="listFunction"
                    :placeholder="'Select Function'"
                    :error-required="false"
                    label="name" />
                </b-form>
              </div>

              <div
                class="btn-add-config"
                @click="addFilterFunction">
                + Add Parameter
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div
        :class="{ 'justify-content-end': (!fieldDetail && !isWorkflow) || (fieldDetail && isWorkflow && isDefault(dataSetup.key)) || (!fieldDetail && isWorkflow && !isDefault(dataSetup.key)) }"
        class="properties-field-button"
      >
        <button
          v-if="(fieldDetail && !isWorkflow) || (fieldDetail && isWorkflow && !isDefault(dataSetup.key))"
          class="button-border"
          @click="deleteConfiguration"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="submitForm(true)"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="submitForm(false)"
          >
            {{ fieldDetail ? 'Update' : 'Add' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console, camelcase */
import { required, requiredIf } from 'vuelidate/lib/validators';
import jColorPicker from '@/components/color-picker/jColorPicker';
import jSwitch from '@/components/inputs/jSwitch';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';

export default {
  name: 'SummaryBlockConfiguration',

  components: {
    jColorPicker,
    jSwitch,
  },

  mixins: [jMixAutoScroll],

  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
    isReduceBlur: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataSetup: {
        key: null,
        name: null,
        color: null,
        type: null,
        is_hidden: false,
        filter_variable: null,
        filter_value: null,
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
      },
      blockTypes: [
        { type: 'first', text: 'First' },
        { type: 'middle', text: 'Middle' },
        { type: 'last', text: 'Last' },
      ],
      problemMessage: '',
      isError: false,
      setFilter: false,
      modeFilter: 'variable',
      showFilterOptions: false,
      filterOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
    };
  },

  computed: {
    genData() {
      const { key, name, color, type, is_hidden, filter_variable, filter_value, filter, filter_function, filterOperator } = this.dataSetup;

      const params = {
        key,
        name,
        color,
        filter_variable: '',
        filter_value: '',
        filter: {},
        filter_function: {},
        filter_operator: filterOperator,
      };

      if (this.isWorkflow) {
        params.type = type;
        params.is_hidden = is_hidden;
      }

      if (filter.length > 0) {
        const counter = {};
        filter.forEach((e) => {
          if (e.key) {
            counter[e.key.id] = (counter[e.key.id] || 0) + 1;
            if (counter[e.key.id] === 2) {
              params.filter[e.key.id] = [params.filter[e.key.id], e.value];
            } else if (counter[e.key.id] > 2) {
              const datas = params.filter[e.key.id];
              datas.push(e.value);
              params.filter[e.key.id] = datas;
            } else {
              params.filter[e.key.id] = e.value;
            }
          }
        });
      } else if (filter_variable && filter_value) {
        params.filter[filter_variable] = filter_value;
      }

      if (filter_function.length > 0) {
        filter_function.forEach((e) => {
          if (e.key) {
            params.filter_function[e.key.id] = e.value;
          }
        });
      }
      return params;
    },

    isWorkflow() {
      return this.type === 'requestor' || this.type === 'approver';
    },
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.key': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataSetup.key =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    setFilter(val) {
      if (!val) {
        this.dataSetup.filter = [
          {
            key: null,
            value: null,
          },
        ];
        this.dataSetup.filter_function = [
          {
            key: null,
            value: null,
          },
        ];
        this.dataSetup.filterOperator = '';
      } else if (val) {
        this.dataSetup.filterOperator = this.fieldDetail ? (this.fieldDetail.filter_operator || 'and') : 'and';
      }
    },
  },

  created() {
    if (this.fieldDetail) {
      this.dataSetup = {
        key: this.fieldDetail.key,
        name: this.fieldDetail.name,
        color: this.fieldDetail.color,
        type: this.isWorkflow ? this.fieldDetail.type : null,
        is_hidden: this.isWorkflow ? this.fieldDetail.is_hidden : false,
        filter_variable: this.fieldDetail.filter_variable || null,
        filter_value: this.fieldDetail.filter_value,
        filter: [{ key: null, value: null }],
        filter_function: [{ key: null, value: null }],
        filterOperator: this.fieldDetail.filter_operator || null,
      };
      this.setFilter = !!this.fieldDetail.filter_variable;

      if (this.fieldDetail.filter) {
        const keyFilter = Object.keys(this.fieldDetail.filter);
        const valueFilter = Object.values(this.fieldDetail.filter);
        if (keyFilter.length > 0) {
          this.dataSetup.filter = [];
          keyFilter.forEach((e, index) => {
            if (typeof valueFilter[index] === 'object') {
              valueFilter[index].forEach((v) => {
                this.dataSetup.filter.push({
                  key: { id: e },
                  value: v,
                });
              });
            } else {
              this.dataSetup.filter.push({
                key: { id: e },
                value: valueFilter[index],
              });
            }
          });
          this.setFilter = true;
        }
      } else if (this.fieldDetail.filter_variable && this.fieldDetail.filter_value) {
        this.dataSetup.filter = [
          {
            key: { id: this.fieldDetail.filter_variable },
            value: this.fieldDetail.filter_value,
          },
        ];
      }

      if (this.fieldDetail.filter_function) {
        const keyFilter = Object.keys(this.fieldDetail.filter_function);
        const valueFilter = Object.values(this.fieldDetail.filter_function);
        if (keyFilter.length > 0) {
          this.dataSetup.filter_function = [];
          keyFilter.forEach((e, index) => {
            this.dataSetup.filter_function.push({
              key: { id: e },
              value: valueFilter[index],
            });
          });
          this.setFilter = true;
        }
      }
    }
  },

  methods: {
    isDefault(key) {
      let status = '';
      if (
        key === 'draft' || key === 'sent' ||
        key === 'approved' || key === 'approved_by_me' ||
        key === 'closed' || key === 'canceled' || key === 'rejected'
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },

    addFilter() {
      this.dataSetup.filter.push({
        key: null,
        value: null,
      });
    },

    deleteFilter(index) {
      this.dataSetup.filter.splice(index, 1);
    },

    addFilterFunction() {
      this.dataSetup.filter_function.push({
        key: null,
        value: null,
      });
    },

    deleteFilterFunction(index) {
      this.dataSetup.filter_function.splice(index, 1);
    },

    closeFilterOptions(id) {
      this.dataSetup.filterOperator = id;
      this.showFilterOptions = false;
    },

    submitForm(isCancel) {
      if (!isCancel) {
        this.$v.dataSetup.$touch();
        if (!this.$v.dataSetup.$error) {
          const mode = this.fieldDetail ? 'edit' : 'add';

          if (!this.isWorkflow) {
            delete this.dataSetup.type;
            delete this.dataSetup.is_hidden;
          }
          this.$emit('submit-configuration', mode, this.genData, isCancel, this.type);
          this.closeConfiguration();
        }
      } else {
        const mode = this.fieldDetail ? 'edit' : 'add';

        this.$emit('submit-configuration', mode, this.genData, isCancel, this.type);
        this.closeConfiguration();
      }
    },

    deleteConfiguration() {
      this.$emit('delete-configuration');
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          key: null,
          name: null,
          color: null,
          type: null,
          is_hidden: null,
          filter_variable: null,
          filter_value: null,
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
        };
        this.$v.dataSetup.$reset();
      }, 400);
    },
  },

  validations() {
    return {
      dataSetup: {
        key: { required },
        name: { required },
        color: { required },
        filter_variable: {},
        filter_value: {},
        filter: {},
        filter_function: {},
        filterOperator: {},
        type: {
          required: requiredIf(() => this.isWorkflow),
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrap-type {
    display: grid;
    grid-template-columns: (repeat(auto-fill, minmax(140px, 1fr)));
    grid-gap: 5px;
    margin-top: 5px;

    .block-type {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #E7E7E7;
      padding: 14px 5px;
      font-family: 'Poppins-Medium';
      font-size: 14px;
      letter-spacing: 0.02rem;
      cursor: pointer;

      img {
        width: 60%;
        height: auto;
        margin-bottom: 5px;
      }
    }
    .type-active {
      background-color: #f2f9ff;
      border-color: #1a85e4;
    }
  }
  .warning-function {
    padding: 12px;
    border-radius: 8px;
    background-color: #FFFDED;
    color: #696014;
    margin: 20px 0;

    img {
      width: auto;
      height: 18px;
      margin-right: 8px;
    }
    .title {
      font-family: 'Poppins-Semibold';
      font-size: 12px;
    }
  }

    @media screen and (max-width: 1366px) {
    .wrap-type {
      grid-template-columns: (repeat(auto-fill, minmax(100px, 1fr)));

      .block-type {
        font-size: 12px;
      }
      img {
        width: 50%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/SummaryBlockConfiguration.vue